import { render, staticRenderFns } from "./BackofficeMedicosCadastradosTable.vue?vue&type=template&id=5abfbaa9&scoped=true"
import script from "./BackofficeMedicosCadastradosTable.vue?vue&type=script&lang=ts"
export * from "./BackofficeMedicosCadastradosTable.vue?vue&type=script&lang=ts"
import style0 from "./BackofficeMedicosCadastradosTable.vue?vue&type=style&index=0&id=5abfbaa9&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5abfbaa9",
  null
  
)

export default component.exports